"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allGlobalEventNames = allGlobalEventNames;
exports.getGlobalEvent = getGlobalEvent;
exports.getGlobalEventOrThrow = getGlobalEventOrThrow;
const events_json_1 = __importDefault(require("@/genfiles/events.json"));
const events = new Map();
events_json_1.default.forEach((card) => {
    events.set(card.name, card);
});
function allGlobalEventNames() {
    return events.keys();
}
function getGlobalEvent(globalEventName) {
    return events.get(globalEventName);
}
function getGlobalEventOrThrow(globalEventName) {
    const globalEvent = getGlobalEvent(globalEventName);
    if (globalEvent === undefined) {
        throw new Error(`global event ${globalEventName} not found`);
    }
    return globalEvent;
}
